// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.social-connect-modal {
  display: flex;
  flex-direction: column;
  max-height: 90vh;
  max-height: 90dvh;
  overflow: hidden;
  outline: none;
}

.social-connect-modal-header {
  flex-shrink: 0;
}

.social-connect-modal-body {
  flex: 1 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}

.social-connect-modal .social-connect-modal-footer {
  flex-shrink: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 12px;
  margin: 0;
  padding: 16px 22px;
  border-top: 1px solid #f0f0f0;
  background: #fff;
}

.social-connect-modal-footer button {
  max-width: 100%;
}

@media (max-width: 600px) {
  .social-connect-modal .social-connect-modal-footer {
    padding: 14px 20px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SocialConnectModal.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;EACb,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,aAAa;EACb,eAAe;EACf,yBAAyB;EACzB,SAAS;EACT,SAAS;EACT,kBAAkB;EAClB,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF","sourcesContent":[".social-connect-modal {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-height: 90vh;\r\n  max-height: 90dvh;\r\n  overflow: hidden;\r\n  outline: none;\r\n}\r\n\r\n.social-connect-modal-header {\r\n  flex-shrink: 0;\r\n}\r\n\r\n.social-connect-modal-body {\r\n  flex: 1 1 auto;\r\n  min-height: 0;\r\n  overflow-y: auto;\r\n  overscroll-behavior: contain;\r\n}\r\n\r\n.social-connect-modal .social-connect-modal-footer {\r\n  flex-shrink: 0;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-end;\r\n  gap: 12px;\r\n  margin: 0;\r\n  padding: 16px 22px;\r\n  border-top: 1px solid #f0f0f0;\r\n  background: #fff;\r\n}\r\n\r\n.social-connect-modal-footer button {\r\n  max-width: 100%;\r\n}\r\n\r\n@media (max-width: 600px) {\r\n  .social-connect-modal .social-connect-modal-footer {\r\n    padding: 14px 20px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
